import { createSlice } from '@reduxjs/toolkit'
import WSUtils from '../../utils/ws-utils';

export const connectionSlice = createSlice({
  name: 'connection',
  initialState: {
    value: false,
  },
  reducers: {
    connect: (state, action) => {
      state.value = true;
    },
    disconnect: (state, action) => {
      state.value = false;
    }
  },
})

export const { connect, disconnect } = connectionSlice.actions

let store = null;
export function configureWithStore(_store) {
  if (!store) {
    store = _store;
    WSUtils.addConnectHandler('update-connection--connect', () => {
      store.dispatch(connect())
    })
    WSUtils.addDisconnectHandler('update-connection--disconnect', () => {
      store.dispatch(disconnect())
    })
  }
}

export default connectionSlice.reducer